import { connect, InitPropertiesAndMethods, IntentCtx, ItemType, RenderItemFormSidebarPanelCtx, RenderModalCtx, RenderPageCtx, } from 'datocms-plugin-sdk';
import { render } from './utils/render';
import ConfigScreen from './entrypoints/ConfigScreen';
import 'datocms-react-ui/styles.css';
import React from 'react';
import ReactDOM from 'react-dom';
import ArticleToStorySidePanel from './entrypoints/ArticleToStorySidePanel';
import RenderStorySidePanel from './entrypoints/RenderStorySidePanel';
import RenderStory from './components/RenderStory';
import RenderWebshopArticleSidePanel from './entrypoints/RenderWebshopArticleSidePanel';
import initStandalonePage from './standaloneIndex';
import RenderWebshopArticlePlugin from './components/RenderWebshopArticle/RenderWebshopArticlePlugin';
import PerisyncAnalyticsPage from './entrypoints/PerisyncAnalyticsPage';
import { Button } from 'datocms-react-ui';
import RenderDialogEditorModal from './components/DialogEditor/RenderDialogEditorModal';
import DialogToolbar from './entrypoints/DialogToolbar';
import ArticleTranslatorSidePanel from './entrypoints/ArticleTranslatorSidePanel/ArticleTranslatorSidePanel';

function isSpecificItemEditorOpen(itemType: ItemType, apiKey: string): boolean {
  const openedApiKey = itemType.attributes.api_key;
  return openedApiKey == apiKey;
}

function isArticleEditorOpen(itemType: ItemType): boolean {
  return isSpecificItemEditorOpen(itemType, "article");
}

function isStoryEditorOpen(itemType: ItemType): boolean {
  return isSpecificItemEditorOpen(itemType, "story");
}

function isProductPageEditorOpen(itemType: ItemType): boolean {
  return isSpecificItemEditorOpen(itemType, "product_page");
}

function isChatEditorOpen(itemType: ItemType): boolean {
  return isSpecificItemEditorOpen(itemType, "chat_dialog");
}

async function initDatoPlugin(): Promise<boolean> {
  try {
    await connect({
      itemFormSidebarPanels: (itemType: ItemType, ctx: InitPropertiesAndMethods) => {
        console.log(itemType);
        if (isArticleEditorOpen(itemType)) {
          return [
            {
              id: "article-to-story-sidebar",
              label: "Convert article to story",
              startOpen: true,
            },
            {
              id: "article-translator-sidebar",
              label: "Translate article",
              startOpen: true,
            },
          ];
        }
        if (isStoryEditorOpen(itemType)) {
          return [
            {
              id: "render-story-sidebar",
              label: "Render story",
              startOpen: true,
            },
          ];
        }
        if (isProductPageEditorOpen(itemType)) {
          return [
            {
              id: "render-product-page",
              label: "Render product page",
              startOpen: true,
            }
          ];
        }
        if (isChatEditorOpen(itemType)) {
          return [
            {
              id: "render-chat-editor",
              label: "Chat editing tools",
              startOpen: true,
            }
          ]
        }

        return [];
      },

      renderModal(modalId: string, ctx: RenderModalCtx) {
        switch (modalId) {
          case 'renderStory':
            return render(<RenderStory ctx={ctx} />);
          case 'renderWebshopArticle':
            return render(<RenderWebshopArticlePlugin ctx={ctx} />);
          case 'renderDialogEditor':
            return render(<RenderDialogEditorModal ctx={ctx} />);
        }
      },

      /**
       * 
       * @param sidebarPaneId This is the currently rendered sidebar panel id. This is in itemFormSidebarPanels id
       * @param ctx 
       */
      renderItemFormSidebarPanel: (sidebarPaneId: string, ctx: RenderItemFormSidebarPanelCtx) => {
        if (sidebarPaneId === "article-to-story-sidebar") {
          ReactDOM.render(
            <React.StrictMode>
              <ArticleToStorySidePanel ctx={ctx} />
            </React.StrictMode>,
            document.getElementById("root")
          );
        } else if (sidebarPaneId === "article-translator-sidebar") {
          ReactDOM.render(
            <React.StrictMode>
              <ArticleTranslatorSidePanel ctx={ctx} />
            </React.StrictMode>,
            document.getElementById("root")
          );
        }else if (sidebarPaneId === "render-story-sidebar") {
          ReactDOM.render(
            <React.StrictMode>
              <RenderStorySidePanel ctx={ctx} />
            </React.StrictMode>,
            document.getElementById("root")
          );
        } else if (sidebarPaneId === "render-product-page") {
          ReactDOM.render(
            <React.StrictMode>
              <RenderWebshopArticleSidePanel ctx={ctx} />
            </React.StrictMode>,
            document.getElementById("root")
          );
        } else if (sidebarPaneId === "render-chat-editor") {
          ReactDOM.render(
            <React.StrictMode>
              <DialogToolbar ctx={ctx}/>
            </React.StrictMode>,
            document.getElementById("root")
          );
        }
      },

      renderPage(pageId, ctx: RenderPageCtx) {
        switch (pageId) {
          case 'perisync-analytics':
            return render(<PerisyncAnalyticsPage ctx={ctx} />);
        }
      },

      mainNavigationTabs(ctx: IntentCtx) {
        return [
          {
            label: 'Perisync analytics',
            icon: 'analytics',
            pointsTo: {
              pageId: 'perisync-analytics',
            },
          },
        ];
      },
    });
    return true;
  } catch (error) {
    console.log({ error })
    return false;
  }
}

initDatoPlugin().then(ret => { if (!ret) initStandalonePage(); })
